import { useEffect, useState } from "react";
import { NewBusinessCard } from "../NewBusinessCard/NewBusinessCard";
import { CardWrapper } from "../../../components/CardWrapper/CardWrapper";
import { PageTitleBlock } from "../../../components/PageTitleBlock/PageTitleBlock";
import styles from "./BusinessListPage.module.scss";
import { useDispatch, useSelector } from "../../../hooks";
import { Loader } from "../../../components/Loader/Loader";
import { ErrorSnackbar } from "../../../components/ErrorSnackbar/ErrorSnackbar";
import { getBusinesses } from "../../../redux/businesses/get-businesses.handler";
import { startBusiness } from "../../../redux/businesses/start-business.handler";
import { useContextNavigate } from "../../../hooks/navigate";
import { BusinessContext } from "../BusinessRoutes";
import { BalanceErrorType, useBalanceError } from "../../../hooks/error";
import { setProfit, setUserExp } from "../../../redux/user";
import { setUserBalanceAndLog } from "../../../redux/user/set-user-balance-and-log.handler";
import { BuyButton } from "../../../components/Buttons/BuyButton/BuyButton";
import { Button } from "../../../components/Buttons/Button/Button";
import { ActionPromptType } from "../../../hooks/prompts";
import { getReferals } from "../../../redux/referals/get-referals.handler";

export const BusinessListPage = () => {
    const [visible, setVisible] = useState(false);

    const { activeBusiness, lib, loading, error } = useSelector(store => store.businesses)
    const balance = useSelector(store => store.user.info.balance);

    const dispatch = useDispatch();
    const navigate = useContextNavigate<BusinessContext>();

    const balanceError = useBalanceError();

    useEffect(() => {
        if (lib.length)
            return;

        dispatch(getBusinesses());
        dispatch(getReferals());
    }, [dispatch, lib]);

    const startBusinessHandler = async () => {
        if (!lib || lib.length === 0)
            return;

        const cost = lib[0].cost;

        if (balance < cost) {
            balanceError(cost, BalanceErrorType.BusinessStart);
            return;
        }

        dispatch(getReferals());
        const resultAction = await dispatch(startBusiness(1));

        if (startBusiness.fulfilled.match(resultAction)) {
            const { balance, exp, profit } = resultAction.payload;
            if (balance !== undefined)
                dispatch(setUserBalanceAndLog(balance));

            if (exp !== undefined)
                dispatch(setUserExp(exp));

            if (profit !== undefined)
                dispatch(setProfit(profit));
        }

        setVisible(true);
    };

    useEffect(() => {
        if (!activeBusiness)
            return;

        navigate(BusinessContext.Detail, { replace: true });
    }, [activeBusiness, navigate]);

    const getButton = () => {
        return lib[0]?.cost
            ? <BuyButton
                cost={ lib[0]?.cost }
                caption='Начать новый'
                handler={ startBusinessHandler }
                actionPropmt={ ActionPromptType.CREATE_BUSINESS_FIRST_TIME }
            />
            : <div><Button
                caption='Начать новый (бесплатно)'
                handler={ startBusinessHandler }
                actionPropmt={ ActionPromptType.CREATE_BUSINESS_FIRST_TIME }
            />
            </div>
    }

    return (
        <>
            <div className={styles.businessPanel}>
                <PageTitleBlock
                    pageTitle=""
                    pageDescription="Бизнес — это деятельность, направленная на систематическое получение прибыли"
                />

                <div className={styles.businessInfo}>
                    { /*<div className={styles.businessInfoBlock}>
                        <span className={styles.businessText}>Бизнесов </span>{" "}
                        <span className={styles.businessCount}>{ lib?.length ?? 0 }</span>
                    </div>*/ }

                    { lib && lib.length && getButton() }
                </div>

                {!visible
                    ? ( <div className={styles.noBusinessMessage}>У вас нет бизнеса</div>)
                    : (
                        <CardWrapper>
                            { lib && lib.map(business =>
                                <NewBusinessCard
                                    key={`business${business.id}`}
                                    {...business}
                                />) }
                        </CardWrapper>
                    )
                }

                <p className={styles.footerText}>
                    Если вы отсутствуете в игре более 8 часов, бизнес перестает приносить
                    прибыль, не забывайте периодически заглядывать в игру
                </p>
            </div>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
};